// extracted by mini-css-extract-plugin
export default {"box":"guide_box__4ooyg","guide_head":"guide_guide_head__x3mMy","gridbox":"guide_gridbox__4xrZZ","p_bold":"guide_p_bold__q93ki"};